<template>
  <div class="add">
    <!--商品信息-->
    <form-info :formData="formData" :isEdit="true" :course_id='$route.params.id' :testData="testData"></form-info>
  </div>
</template>

<script>
import drawForm from "./audio-form";

import {
  _courseSingTopic,
} from "@/api/course";

export default {
  created() {
    this.courseSingTopic();
  },
  components: {
    "form-info": drawForm
  },
  data() {
    return {
      formData: {},
      testData:{
        
      }
    };
  },
  methods: {
    //获取单条数据信息
    courseSingTopic(){
      _courseSingTopic({
        params:{
          course_id:this.$route.params.id
        }
      })
      .then((res) => {
        // console.log(res);
        if(res.resultCode==1){
          this.formData=res.result;
        }else{
          this.$message.error(res.errorMsg);
        }
      })
    }
  }
};
</script>

<style scoped lang="less">
</style>